import React, { ReactNode } from "react";

interface ChatContainerProps {
  children: ReactNode;
}

/**
 * ChatContainer - Wrapper simple pour le contenu chat
 * 
 * Reçoit les dimensions du parent (ResponsiveLayout)
 * Ne gère PAS le responsive lui-même
 */
export function ChatContainer({ children }: ChatContainerProps) {
  return (
    <div className="flex flex-col h-full bg-[#0a0a0a]">
      {children}
    </div>
  );
}
